import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  helpMessage: css`
    color: ${colors.yellow30};
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
  `,
}
